import Heading from 'molecules/Heading';
import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import Reveal from 'components/Animations/Reveal';

import { hasArrayValues } from 'utils/array/arrays';

import type { SpeakerCardsConfigProps } from 'components/SpeakerCards/config';
import type { FC } from 'react';

const SpeakerCards: FC<SpeakerCardsConfigProps> = props => {
  const {
    sectionProps,
    rest: { heading, speakers, andMoreText },
  } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-16">
        {heading && (
          <div className="lg:col-span-1">
            <Heading {...heading} alignment="left" sidePadding="none" />
          </div>
        )}

        {hasArrayValues(speakers) && (
          <div className="grid grid-cols-3 gap-3 sm:gap-5 lg:col-span-2 lg:grid-cols-4">
            {speakers.map((speaker, index) => (
              <Reveal
                key={speaker.id ?? `speaker-${index}`}
                delay={index * 0.05}
                className="flex flex-col gap-2 rounded-lg bg-white p-2 shadow-sm sm:gap-3 sm:p-3"
              >
                {speaker?.photo?.file ? (
                  <Image
                    {...speaker.photo.file}
                    alt={speaker.photo.alt || speaker.name || 'Speaker headshot'}
                    url={speaker.photo.file.url}
                    noFill
                    width={300}
                    height={300}
                    objectCover
                    className="aspect-square w-full rounded-md"
                    borderRadius="6px"
                  />
                ) : (
                  <div className="flex aspect-square w-full items-center justify-center rounded-md bg-gray-200">
                    <Icon icon="user-circle" size={64} iconColor="text-gray-400" />
                  </div>
                )}

                <div className="flex flex-col gap-0.5 sm:gap-1">
                  {speaker?.name && (
                    <div className="text-[10px] font-semibold leading-tight text-gray-900 sm:text-md">
                      {speaker.name}
                    </div>
                  )}
                  {speaker?.title && (
                    <div className="text-[8px] leading-snug text-gray-600 sm:text-xs sm:leading-5">{speaker.title}</div>
                  )}
                </div>
              </Reveal>
            ))}

            {andMoreText && (
              <div className="col-span-full flex items-center justify-start whitespace-nowrap p-2 text-2xl text-gray-400 sm:p-4 lg:col-span-1 lg:justify-center lg:text-3xl">
                {andMoreText}
              </div>
            )}
          </div>
        )}
      </div>
    </Section>
  );
};

export default SpeakerCards;
